const session_new = document.querySelector('.session_new');
const check_rgpd = document.getElementById('check-rgpd');
const submit_button = document.querySelector('.btn');

const newSession = () => {
  if (session_new) {
    check_rgpd.addEventListener('click', () => {
      if (check_rgpd.checked) {
        submit_button.disabled = false;
      } else {
        submit_button.disabled = true;
      }
    })
  }
}
export { newSession };
